import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useListCategoriesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Categories',
  props: {
    categoryCounts: null,
    selectedCategoryIds: null
  },
  emits: ['category-clicked'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var variables = computed(function () {
      return {
        input: {
          onlyRootElements: true
        }
      };
    });
    var selectedCategoryIds = ref([]);
    var areIdArraysEqual = function areIdArraysEqual(a, b) {
      if (a.length !== b.length) return false;
      return a.every(function (value, index) {
        return value === b[index];
      });
    };
    watch(function () {
      return props.selectedCategoryIds;
    }, function (value) {
      var nextValue = _toConsumableArray(value || []);
      if (areIdArraysEqual(selectedCategoryIds.value, nextValue)) return;
      selectedCategoryIds.value = nextValue;
    }, {
      immediate: true,
      deep: true
    });
    watch(selectedCategoryIds, function () {
      var propValue = _toConsumableArray(props.selectedCategoryIds || []);
      if (areIdArraysEqual(selectedCategoryIds.value, propValue)) return;
      emit('category-clicked', selectedCategoryIds.value);
    }, {
      deep: true
    });
    var _useListCategoriesQue = useListCategoriesQuery(variables),
      result = _useListCategoriesQue.result;
    var countsByCategoryId = computed(function () {
      var map = new Map();
      var _iterator = _createForOfIteratorHelper(props.categoryCounts || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _row$categoryId;
          var row = _step.value;
          map.set(String((_row$categoryId = row.categoryId) !== null && _row$categoryId !== void 0 ? _row$categoryId : 'uncategorized'), row.count || 0);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return map;
    });
    var uncategorizedCount = computed(function () {
      return countsByCategoryId.value.get('uncategorized') || 0;
    });
    var allKpisCount = computed(function () {
      var sum = 0;
      var _iterator2 = _createForOfIteratorHelper(countsByCategoryId.value.values()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var value = _step2.value;
          sum += value || 0;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return sum;
    });
    var categories = computed(function () {
      var _result$value;
      var allCategoriesMap = new Map();
      var _processCategory = function processCategory(cat) {
        allCategoriesMap.set(cat.id, _objectSpread(_objectSpread({}, cat), {}, {
          metricCount: countsByCategoryId.value.get(String(cat.id)) || 0
        }));
        if (cat.subcategories) {
          cat.subcategories.forEach(_processCategory);
        }
      };
      var rootCategories = ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listCategories) || [];
      rootCategories.forEach(_processCategory);
      var buildTree = function buildTree(rootCat) {
        var _allCategoriesMap$get;
        var categoryObject = {
          id: rootCat.id,
          label: rootCat.label,
          metricCount: ((_allCategoriesMap$get = allCategoriesMap.get(rootCat.id)) === null || _allCategoriesMap$get === void 0 ? void 0 : _allCategoriesMap$get.metricCount) || 0,
          children: (rootCat.subcategories || []).map(function (subcat) {
            var _allCategoriesMap$get2;
            return {
              id: subcat.id,
              label: subcat.label,
              metricCount: ((_allCategoriesMap$get2 = allCategoriesMap.get(subcat.id)) === null || _allCategoriesMap$get2 === void 0 ? void 0 : _allCategoriesMap$get2.metricCount) || 0,
              children: []
            };
          })
        };
        return categoryObject;
      };
      var tree = rootCategories.map(buildTree);

      // Update metricCount for each node so that if a node has children, its count
      // becomes the sum of its children's metricCounts.
      var _updateMetricCounts = function updateMetricCounts(node) {
        if (node.children && node.children.length > 0) {
          var sum = 0;
          node.children.forEach(function (child) {
            sum += _updateMetricCounts(child);
          });
          // Override parent's count to be the sum of its children's counts.
          node.metricCount = sum;
        }
        return node.metricCount;
      };
      tree.forEach(_updateMetricCounts);
      return tree;
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      variables: variables,
      selectedCategoryIds: selectedCategoryIds,
      areIdArraysEqual: areIdArraysEqual,
      result: result,
      countsByCategoryId: countsByCategoryId,
      uncategorizedCount: uncategorizedCount,
      allKpisCount: allKpisCount,
      categories: categories
    };
  }
});